export { useGraffitiObjectToFile } from "./composable";
import ObjectToFile from "./ObjectToFile.vue";
export const GraffitiObjectToFile = ObjectToFile;
